<template>
  <div class="library section">
    <p v-if="loading">Loading...</p>
    <div v-else>
      <b-field>
        <b-select
          placeholder="Language"
          v-model="filterLanguage"
          icon-pack="fas"
          icon="globe"
        >
          <option v-for="lang in languages" :key="lang" :value="lang">
            {{ lang }}
          </option>
        </b-select>
      </b-field>
      <div class="columns is-centered is-multiline">
        <div
          v-for="book in filteredBooks"
          :key="book.id"
          class="book column is-6-tablet is-4-desktop"
        >
          <BookCard
            :book="book"
            :userOverlay="userOverlayByBookId[book.id]"
            :loadingOverlay="loadingOverlay"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookCard from "@/components/BookCard";
import authMixin from "@/mixins/authMixin";
import dataService from "../services/dataService";
import { mapActions, mapState } from "vuex";

export default {
  name: "Library",
  components: { BookCard },
  mixins: [authMixin],
  data() {
    return {
      loading: true,
      loadingOverlay: false,
      userOverlayByBookId: {},
      filterLanguage: undefined
    };
  },
  methods: {
    ...mapActions(["fetchBooksAction"])
  },
  computed: {
    ...mapState(["books"]),
    languages() {
      return ["All", ...new Set(this.books.map(b => b.language))];
    },
    filteredBooks() {
      return this.filterLanguage === "All" || !this.filterLanguage
        ? this.books
        : this.books.filter(b => b.language === this.filterLanguage);
    }
  },
  async created() {
    if (this.books.length === 0) await this.fetchBooksAction();
    this.loading = false;
    if (this.oidcIsAuthenticated) {
      this.loadingOverlay = true;
      const overlayInfos = await dataService.getUserOverlayInfo();
      this.userOverlayByBookId = Object.assign(
        {},
        ...overlayInfos.map(i => ({ [i.bookId]: i }))
      );
      this.loadingOverlay = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.book {
  padding-bottom: 25px;
}
</style>
